module.exports = __webpack_public_path__ + "img/apoio-iabin.a5369374.png";